import { toast } from "sonner";
import { Star, Trash2 } from "lucide-react";
import { api, fmtErr, img } from "@/lib/api";

const Stars = ({ n }) => (
  <span className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-3.5 w-3.5 ${i <= n ? "fill-[#d8b4fe] text-[#d8b4fe]" : "text-[#3b1d63]"}`} />
    ))}
  </span>
);

export const ReviewsTab = ({ reviews, reload }) => {
  const remove = async (r) => {
    if (!window.confirm("Delete this review?")) return;
    try { await api.delete(`/admin/reviews/${r.id}`); toast.success("Review deleted"); reload(); } catch (e) { toast.error(fmtErr(e)); }
  };
  if (!reviews.length) return <p className="py-16 text-center text-[#cbbbe6]" data-testid="admin-reviews-empty">No reviews yet.</p>;
  return (
    <ul className="divide-y divide-[#281245] border-y border-[#281245]" data-testid="admin-reviews">
      {reviews.map((r) => (
        <li key={r.id} className="flex items-start gap-4 py-5" data-testid={`admin-review-${r.id}`}>
          {r.photos?.[0] ? <img src={img(r.photos[0])} alt="" className="h-16 w-14 shrink-0 object-cover" /> : null}
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-3">
              <Stars n={r.rating} />
              <span className="text-sm text-[#f3eefc]">{r.name}</span>
              <span className="font-mono-j text-xs text-[#a78bce]">{r.product_title} · {new Date(r.created_at).toLocaleDateString("en-CA")}</span>
            </div>
            {r.text && <p className="mt-2 text-sm text-[#cbbbe6]">{r.text}</p>}
          </div>
          <button onClick={() => remove(r)} className="p-2 text-[#cbbbe6] hover:text-red-400" aria-label="Delete review" data-testid={`admin-review-delete-${r.id}`}>
            <Trash2 className="h-4 w-4" />
          </button>
        </li>
      ))}
    </ul>
  );
};
